import React from 'react';

import ExercisePreviewContainer from '@ts-core/modules/exercises/components/ExercisePreviewContainer';
import QuestionsContainer from '@ts-core/modules/exercises/components/QuestionsContainer';

import { FillInTheBlanksExerciseWithResults } from '../../types';
import FillInTheBlanksQuestionPreview from '../FillInTheBlanksQuestionPreview';

interface FillInTheBlanksExercisePreviewProps {
  exercise?: FillInTheBlanksExerciseWithResults;
  loading?: boolean;
  hideScores?: boolean;
  hideQuestionBackgroundColor?: boolean;
}

const FillInTheBlanksExercisePreview = (props: FillInTheBlanksExercisePreviewProps) => {
  const { exercise, loading = false, hideScores = false, hideQuestionBackgroundColor = false } = props;

  return (
    <ExercisePreviewContainer exercise={exercise} loading={loading} layout="column">
      <QuestionsContainer
        questions={exercise?.questions}
        loading={loading}
        renderQuestion={(index, question) => (
          <FillInTheBlanksQuestionPreview
            key={question?._id || index}
            question={question}
            loading={loading}
            hideScores={hideScores}
            hideQuestionBackgroundColor={hideQuestionBackgroundColor}
          />
        )}
      />
    </ExercisePreviewContainer>
  );
};

export default FillInTheBlanksExercisePreview;
